import {enums} from "./model";

export class MinLosLevelColorDescription {

    static disableMinLosColorLevelDescriptions(){
        // Disable min los level color label boxes
        document.getElementsByClassName('global_house_color')[0].style.display = 'none';
        document.getElementsByClassName('house_color')[0].style.display = 'none';
        document.getElementsByClassName('room_type_color')[0].style.display = 'none';
        document.getElementsByClassName('room_color')[0].style.display = 'none';

        // Disable min los level color label descriptions
        document.getElementsByClassName('global_house_description')[0].style.display = 'none';
        document.getElementsByClassName('house_description')[0].style.display = 'none';
        document.getElementsByClassName('room_type_description')[0].style.display = 'none';
        document.getElementsByClassName('room_description')[0].style.display = 'none';
    }

    static enableGlobalHouseColorDescription(){
        document.getElementsByClassName('global_house_color')[0].style.display = 'block';
        document.getElementsByClassName('global_house_description')[0].style.display = 'block';
        document.getElementsByClassName('global_house_color')[0].style.backgroundColor = enums.MinLosLevelColors.GLOBAL_HOUSE;
    }

    static enableHouseColorDescription(){
        document.getElementsByClassName('house_color')[0].style.display = 'block';
        document.getElementsByClassName('house_description')[0].style.display = 'block';
        document.getElementsByClassName('house_color')[0].style.backgroundColor = enums.MinLosLevelColors.HOUSE;

    }

    static enableRoomTypeColorDescription(){
        document.getElementsByClassName('room_type_color')[0].style.display = 'block';
        document.getElementsByClassName('room_type_description')[0].style.display = 'block';
        var select = document.getElementById('levels');
        var value = select.options[select.selectedIndex].text;
        var level = select.options[select.selectedIndex].value;
        if(level == enums.levelSelector.CATEGORY){
            document.getElementsByClassName('room_type_description')[0].innerHTML = value;
        }
        document.getElementsByClassName('room_type_color')[0].style.backgroundColor = enums.MinLosLevelColors.ROOM_TYPE;

    }

    static enableRoomColorDescription(){
        document.getElementsByClassName('room_color')[0].style.display = 'block';
        document.getElementsByClassName('room_description')[0].style.display = 'block';
        var select = document.getElementById('levels');
        var value = select.options[select.selectedIndex].text;
        var level = select.options[select.selectedIndex].value;
        if(level == enums.levelSelector.ROOM){
            document.getElementsByClassName('room_description')[0].innerHTML = value;
        }
        document.getElementsByClassName('room_color')[0].style.backgroundColor = enums.MinLosLevelColors.ROOM;

    }

}